import {
  ContentExtractorFieldType,
  ContentTakeMode,
  ReplaceMatchMode,
  TransformerType,
} from "@/constants/scraper";

export type TransformerFormState = {
  type: string;
  what: string;
  with: string;
  occurence: string;
  from: string;
  to: string;
  value: string;
  index: string;
};

export function emptyTransformer(): TransformerFormState {
  return {
    type: TransformerType.Trim,
    what: "",
    with: "",
    occurence: ReplaceMatchMode.First,
    from: "0",
    to: "",
    value: "",
    index: "0",
  };
}

export function transformerFromApi(raw: unknown): TransformerFormState {
  const r = (raw && typeof raw === "object" ? raw : {}) as Record<
    string,
    unknown
  >;
  const occ =
    r.occurence != null ? String(r.occurence) : ReplaceMatchMode.First;
  return {
    type: typeof r.type === "string" ? r.type : TransformerType.Trim,
    what: r.what != null ? String(r.what) : "",
    with: r.with != null ? String(r.with) : "",
    occurence:
      occ === ReplaceMatchMode.First
        ? ReplaceMatchMode.First
        : ReplaceMatchMode.All,
    from: r.from != null ? String(r.from) : "0",
    to: r.to != null ? String(r.to) : "",
    value: r.value != null ? String(r.value) : "",
    index: r.index != null ? String(r.index) : "0",
  };
}

export function transformerToApi(
  t: TransformerFormState,
): Record<string, unknown> {
  const base: Record<string, unknown> = { type: t.type };
  switch (t.type) {
    case TransformerType.Replace:
      base.what = t.what;
      base.with = t.with;
      base.occurence =
        t.occurence === ReplaceMatchMode.First ? ReplaceMatchMode.First : "all";
      break;
    case TransformerType.Substring:
    case TransformerType.Slice: {
      const from = Number.parseInt(t.from, 10);
      const to = Number.parseInt(t.to, 10);
      base.from = Number.isFinite(from) ? from : 0;
      base.to = Number.isFinite(to) ? to : 0;
      break;
    }
    case TransformerType.Split:
      base.value = t.value;
      base.index = Number.parseInt(t.index, 10) || 0;
      break;
    case TransformerType.PadEnd:
    case TransformerType.PadStart:
      base.index = Number.parseInt(t.index, 10) || 0;
      base.value = t.value;
      break;
    default:
      break;
  }
  return base;
}

export type ExtractorFormState = {
  property: string;
  selector: string;
  type: string;
  take: string;
  transformers: TransformerFormState[];
  remove: string[];
};

export function emptyExtractor(): ExtractorFormState {
  return {
    property: "",
    selector: "",
    type: ContentExtractorFieldType.Text,
    take: ContentTakeMode.Normal,
    transformers: [],
    remove: [],
  };
}
